module.exports = __webpack_public_path__ + "static/media/member2.d02953c2.jpg";